export default "/images/folder.svg?131f06eb968394918a3f4b04151f5a03";